import { c as _c } from "react/compiler-runtime";
// This component should NOT have "use client"
import type { ReactNode } from "react";
import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { graphqlShopifyStorefront, readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { Image_Fragment, MediaImage_Fragment, MediaConnectionMasked_Fragment, Video_Fragment } from "#/graphql/shopify-storefront/fragments";
import { transformShopifyImageToNextImage } from "@repo/shopify/utilities/next";
import { GridItemClient } from "./grid-item-client"; // Import the new client component

export const GridItem_Localization_Fragment = graphqlShopifyStorefront(`
  fragment GridItem_Localization on Localization {
    ...LinkedData_Localization
    availableCountries {
      availableLanguages {
        isoCode
      }
      isoCode
    }
  }
`
// [LinkedData_Localization_Fragment],
);
export const GridItem_Product_Fragment = graphqlShopifyStorefront(`
  fragment GridItem_Product on Product {
    ...LinkedData_Product
    ...PriceAndCompareAtPrice_Product
    handle
    id
    mediaConnectionMaskedGridItem: media(first: 2) {
      ...MediaConnectionMasked
    }
    priceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    tags
    title
  }
`
// [
//   MediaConnectionMasked_Fragment,
//   LinkedData_Product_Fragment,
//   PriceAndCompareAtPrice_Product_Fragment,
// ],
);
export const GridItem_Shop_Fragment = graphqlShopifyStorefront(`
  fragment GridItem_Shop on Shop {
    ...LinkedData_Shop
    brand {
      logo {
        alt
        image {
          ...Image
        }
      }
    }
    name
  }
`
// [Image_Fragment, LinkedData_Shop_Fragment],
);
export async function GridItem(t0) {
  const $ = _c(17);
  const {
    className,
    delay: t1,
    hide: t2,
    lang,
    loading,
    localizationMasked,
    preload,
    productMasked: productMaskedSuper,
    shopMasked,
    sizes
  } = t0;
  const delay = t1 === undefined ? 0 : t1;
  const hide = t2 === undefined ? false : t2;
  if (hide) {
    return null;
  }
  let images;
  let t3;
  let t4;
  if ($[0] !== productMaskedSuper) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const product = readFragmentShopifyStorefront(GridItem_Product_Fragment, productMaskedSuper);
      if (!product) {
        t4 = null;
        break bb0;
      }
      const {
        mediaConnectionMaskedGridItem
      } = product;
      const mediaMasked = readFragmentShopifyStorefront(MediaConnectionMasked_Fragment, mediaConnectionMaskedGridItem).edges.map(_temp);
      images = mediaMasked.filter(_temp2).map(_temp3).map(_temp4).filter(Boolean).map(transformShopifyImageToNextImage);
      t3 = mediaMasked.filter(_temp5).map(_temp6);
    }
    $[0] = productMaskedSuper;
    $[1] = images;
    $[2] = t3;
    $[3] = t4;
  } else {
    images = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  const videos = t3;
  const primaryImage = images?.[0];
  const secondaryImage = images?.[1];
  const video = videos?.[0];
  let t5;
  if ($[4] !== className || $[5] !== delay || $[6] !== lang || $[7] !== loading || $[8] !== localizationMasked || $[9] !== preload || $[10] !== primaryImage || $[11] !== productMaskedSuper || $[12] !== secondaryImage || $[13] !== shopMasked || $[14] !== sizes || $[15] !== video) {
    t5 = <GridItemClient className={className} delay={delay} lang={lang} loading={loading} preload={preload} sizes={sizes} primaryImage={primaryImage} secondaryImage={secondaryImage} video={video} productMaskedSuper={productMaskedSuper} localizationMasked={localizationMasked} shopMasked={shopMasked} />;
    $[4] = className;
    $[5] = delay;
    $[6] = lang;
    $[7] = loading;
    $[8] = localizationMasked;
    $[9] = preload;
    $[10] = primaryImage;
    $[11] = productMaskedSuper;
    $[12] = secondaryImage;
    $[13] = shopMasked;
    $[14] = sizes;
    $[15] = video;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
function _temp6(mediumMasked_1) {
  return readFragmentShopifyStorefront(Video_Fragment, mediumMasked_1);
}
function _temp5(medium_0) {
  return medium_0.__typename === "Video";
}
function _temp4(mediaImage) {
  return readFragmentShopifyStorefront(Image_Fragment, mediaImage.imageMasked);
}
function _temp3(mediumMasked_0) {
  return readFragmentShopifyStorefront(MediaImage_Fragment, mediumMasked_0);
}
function _temp2(medium) {
  return medium.__typename === "MediaImage";
}
function _temp(t0) {
  const {
    node: mediumMasked
  } = t0;
  return mediumMasked;
}